import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialService = {
    list: async () => axios.get(`${API_URL}/materials-list`).then(({data}) => data).catch((err) => { throw err }),
    save: async (formData, id) => {
        if (id) {
            formData.append('_method', 'PUT');
            return axios.post(`${API_URL}/materials/${id}`, formData).then(({data}) => data).catch((err) => { throw err })
        }

        return axios.post(`${API_URL}/materials`, formData).then(({data}) => data).catch((err) => { throw err })
    },
    getById: async (id) => axios.get(`${API_URL}/materials/${id}`).then(({data}) => data).catch((err) => {throw err}),
    delete: async (id) => axios.delete(`${API_URL}/materials/${id}`).then(({data}) => data).catch((err) => {throw err}),
    hasMovements: async (id) => axios.get(`${API_URL}/materials/${id}/movement-check`).then(({data}) => data).catch((err) => {throw err}),
        optionsNonUnique: async () => axios.get(`${API_URL}/materials/options-non-unique/all`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    optionsAll: async () => axios.get(`${API_URL}/materials/options/all`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    optionsCaution: async () => axios.get(`${API_URL}/materials/get/materialCaution`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
}

export default MaterialService;